import { Component, OnInit, EventEmitter } from '@angular/core';
import {
  HttpService,
  SessionService,
  MessageService,
  TableConfiguration,
  TableColumns,
  MenuBreadCrumb,
  HeaderFilters,
  LocalStorageService,
} from 'brainloper-ui';
import { Router, ActivatedRoute } from '@angular/router';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { Provider } from 'src/app/models/administration/provider';
import { BaseResponse } from 'src/app/models/commos/base-response';

@Component({
    selector: 'app-providers',
    templateUrl: './providers.component.html',
    styleUrls: ['./providers.component.scss'],
    standalone: false
})
export class ProvidersComponent implements OnInit {

  public menuBreadCrumb:Array<MenuBreadCrumb>= [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Terceros",
    current:true
    }
  ]

  public urlGetTerceros: string = `${EndpointDictionary.Provider.PROVIDER_TABLE}`;
  private urlTerceros: string = `${EndpointDictionary.Provider.CRUD_PROVIDER_DATA}`;
  roleId:number

  headerFilters: Array<HeaderFilters> = [
    {
      tN: "tipo_proveedor",
      labelFilter:"Tipo",
      urlData: EndpointDictionary.ProviderType.PROVIDER_TYPE_COMBO,
      visibleField:"name",
      primaryKey:"id",
      type:"select",
      value:"",
      active:true
    }
  ]

  recargarTablaTerceros = new EventEmitter<any>();
  public configurationTerceros: TableConfiguration = {
    edit: true,
    add: true,
    selectable: true,
    addPer: true,
    editPer: true,
    primaryKey: 'id'

  };
  public columnasTerceros: TableColumns<Provider>[] = [
    {
      ID: 'providerName',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'types',
      label: 'Relación',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'companyPhone',
      label: 'Tel. empresa',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'manager',
      label: 'Encargado',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'managePhone',
      label: 'Tel. Encargado',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'email',
      label: 'Correo',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },

    {
      ID: 'city',
      label: 'Ciudad',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];


constructor(
    private http: HttpService,
    private router: Router,
    private session: SessionService,
    private activeRoute: ActivatedRoute,
    private message: MessageService,
    private storage: LocalStorageService
  ) {
    this.roleId = this.storage.get<number>('roleId')
  }

  ngOnInit(): void {
  }



  agregarTerceros($event) {
    this.session.setData('redireccion', 'nuevo');
    this.router.navigate(['detalle'], { relativeTo: this.activeRoute });
  }

  editarTerceros($event) {
    this.http
      .getData(`${this.urlTerceros}/${$event[0].id}`)
      .subscribe(
        (res: BaseResponse<Array<Provider>>) => {
          if (res['code'] === 0) {
            this.session.setData('tercerosData', res['body'][0]);
            this.session.setData('redireccion', 'actualizar');
            this.router.navigate(['detalle'], { relativeTo: this.activeRoute });
          } else {
            this.message.Error(
              'Error!',
              `Codigo:${res['code']} - Mensaje: ${res['message']}`
            );
          }
        },
        (err) => {
          this.message.Error('Error!', err.message);
        }
      );
  }

  // async eliminarTerceros($event) {

  //   let res =  await this.deleteItem.deleteD($event, this.urlTerceros, "id", "Tercero", "Terceros")
  //       this.recargarTablaTerceros.emit();

  // }

  seleccionadosTerceros($event) {
    ////console.log($event);
  }

  clickFilaTerceros($event) {
  }


}
